// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
// import { Container, Row, Col } from "react-bootstrap";

// import meter1 from "../assets/img/meter1.svg";
// import meter2 from "../assets/img/meter2.svg";
// import meter3 from "../assets/img/meter3.svg";
// import colorSharp from "../assets/img/color-sharp.png";
// import colorSharp2 from "../assets/img/color-sharp2.png";
// import { ArrowRightSquare } from "react-bootstrap-icons";

// export const Skills = () => {
//   const responsive = {
//     superLargeDesktop: {
//       breakpoint: { max: 4000, min: 3000 },
//       items: 5,
//     },
//     desktop: {
//       breakpoint: { max: 3000, min: 1024 },
//       items: 3,
//     },
//     tablet: {
//       breakpoint: { max: 1024, min: 464 },
//       items: 2,
//     },
//     mobile: {
//       breakpoint: { max: 464, min: 0 },
//       items: 1,
//     },
//   };

//   return (
//     <section className="skill" id="skills">
//       <Container>
//         <Row>
//           <Col>
//             <div className="skill-bx">
//               <h2>Skills</h2>

//               <p>
//                 My technical experience spans systems programming,
//                 telecom networking, security, full-stack development,
//                 databases, and AI-powered applications. I enjoy solving
//                 complex engineering problems and building reliable,
//                 production-ready software.
//               </p>

//               <Carousel
//                 responsive={responsive}
//                 infinite={true}
//                 className="skill-slider"
//               >
//                 <div className="item">
//                   <img src={meter1} alt="Software development" />
//                   <h5>
//                     C++, Java & Python
//                   </h5>
//                 </div>

//                 <div className="item">
//                   <img src={meter2} alt="Networking and security" />
//                   <h5>
//                     RTP, SRTP, DTLS & SIP
//                   </h5>
//                 </div>

//                 <div className="item">
//                   <img src={meter3} alt="Full-stack development" />
//                   <h5>
//                     React, Node.js & Express
//                   </h5>
//                 </div>

//                 <div className="item">
//                   <img src={meter1} alt="Databases" />
//                   <h5>
//                     MongoDB, MySQL & SQL
//                   </h5>
//                 </div>

//                 <div>
//                   <br />
//                   <br />
//                   <h3>
//                     More Skills <ArrowRightSquare size={25} />
//                   </h3>
//                 </div>

//                 <div className="item">
//                   <br />
//                   <h5>Data Structures & Algorithms</h5>
//                   <br />
//                   <h5>OOPs & DBMS</h5>
//                   <br />
//                   <h5>Operating Systems</h5>
//                 </div>

//                 <div className="item">
//                   <br />
//                   <h5>Computer Networks</h5>
//                   <br />
//                   <h5>Distributed Systems</h5>
//                   <br />
//                   <h5>System Design</h5>
//                 </div>

//                 <div className="item">
//                   <br />
//                   <h5>Docker</h5>
//                   <br />
//                   <h5>Linux</h5>
//                   <br />
//                   <h5>Git & Jira</h5>
//                 </div>

//                 <div className="item">
//                   <br />
//                   <h5>Wireshark</h5>
//                   <br />
//                   <h5>Baresip</h5>
//                   <br />
//                   <h5>Linphone</h5>
//                 </div>

//                 <div className="item">
//                   <br />
//                   <h5>REST APIs</h5>
//                   <br />
//                   <h5>JWT Authentication</h5>
//                   <br />
//                   <h5>WebSockets</h5>
//                 </div>

//                 <div className="item">
//                   <br />
//                   <h5>RAG & Semantic Search</h5>
//                   <br />
//                   <h5>ChromaDB</h5>
//                   <br />
//                   <h5>Gemini API</h5>
//                 </div>
//               </Carousel>
//             </div>
//           </Col>
//         </Row>
//       </Container>

//       <img
//         className="background-image-left"
//         src={colorSharp}
//         alt=""
//       />

//       <img
//         className="background-image-right"
//         src={colorSharp2}
//         alt=""
//       />
//     </section>
//   );
// };


import { Container, Row, Col } from "react-bootstrap";
import {
  SiCplusplus,
//   SiJava,
  SiPython,
  SiJavascript,
  SiTypescript,
  SiHtml5,
  SiTailwindcss,
  SiReact,
  SiNodedotjs,
  SiExpress,
  SiMongodb,
  SiMysql,
  SiDocker,
  SiGit,
  SiLinux,
  SiAndroid,
  SiWireshark,
  SiPostman,
  SiGithub,
  SiFigma,
//   SiAdobephotoshop,
//   SiAdobepremierepro,
} from "react-icons/si";

import {
  FaDatabase,
  FaNetworkWired,
  FaLock,
  FaCode,
} from "react-icons/fa";

import colorSharp from "../assets/img/color-sharp.png";
import colorSharp2 from "../assets/img/color-sharp2.png";

const skillGroups = [
  {
    title: "Languages",
    skills: [
      { name: "C++", icon: SiCplusplus },
    //   { name: "Java", icon: SiJava },
      { name: "Python", icon: SiPython },
      { name: "JavaScript", icon: SiJavascript },
      { name: "TypeScript", icon: SiTypescript },
      { name: "SQL", icon: FaDatabase },
    ],
  },
  {
    title: "Frontend",
    skills: [
      { name: "React.js", icon: SiReact },
      { name: "HTML5", icon: SiHtml5 },
      { name: "Tailwind CSS", icon: SiTailwindcss },
    ],
  },
  {
    title: "Backend",
    skills: [
      { name: "Node.js", icon: SiNodedotjs },
      { name: "Express.js", icon: SiExpress },
      { name: "REST APIs", icon: FaCode },
      { name: "WebSockets", icon: FaNetworkWired },
    ],
  },
  {
    title: "Databases",
    skills: [
      { name: "MongoDB", icon: SiMongodb },
      { name: "MySQL", icon: SiMysql },
      { name: "DBMS", icon: FaDatabase },
    ],
  },
  {
    title: "Systems & Security",
    skills: [
      { name: "Linux", icon: SiLinux },
      { name: "Docker", icon: SiDocker },
      { name: "Git", icon: SiGit },
      { name: "Wireshark", icon: SiWireshark },
      { name: "Cryptography", icon: FaLock },
    ],
  },
  {
    title: "Development Tools",
    skills: [
      { name: "GitHub", icon: SiGithub },
      { name: "Postman", icon: SiPostman },
      { name: "Android", icon: SiAndroid },
      { name: "Figma", icon: SiFigma },
    ],
  },
  {
    title: "Design",
    skills: [
    //   { name: "Photoshop", icon: SiAdobephotoshop },
    //   { name: "Premiere Pro", icon: SiAdobepremierepro },
    ],
  },
];

export const Skills = () => {
  return (
    <section className="skill" id="skills">
      <Container>
        <Row>
          <Col>
            <div className="skill-bx">

              <span className="section-kicker">
                WHAT I WORK WITH
              </span>

              <h2>Technical Skills</h2>

              <p>
                A practical toolkit built through production engineering,
                software development, system debugging, and continuous
                experimentation.
              </p>

              <div className="skills-grid">
                {skillGroups.map((group) => (
                  <div className="skill-group" key={group.title}>

                    <h3>{group.title}</h3>

                    <div className="skill-items">
                      {group.skills.map((skill) => {
                        const Icon = skill.icon;

                        return (
                          <div
                            className="skill-item"
                            key={skill.name}
                            title={skill.name}
                          >
                            <Icon className="skill-icon" />
                            <span>{skill.name}</span>
                          </div>
                        );
                      })}
                    </div>

                  </div>
                ))}
              </div>

            </div>
          </Col>
        </Row>
      </Container>

      <img
        className="background-image-left"
        src={colorSharp}
        alt=""
        loading="lazy"
      />

      <img
        className="background-image-right"
        src={colorSharp2}
        alt=""
        loading="lazy"
      />
    </section>
  );
};
